import {AnyAction} from "redux";
import {ADD_SCORE, SET_SCORE} from "../actions/action";
import * as _ from 'lodash';


//  define selectors

export const getScore = state => state.score;


//  define the initial state

const initial_state: number = 0;


/**
 * reducer: handle score
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function score(state: number = initial_state, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_SCORE:
        {
            const {payload} = action;
            const {score} = payload;

            return score;
        }

        case ADD_SCORE:
        {
            const {payload} = action;
            const {score} = payload;

            return state + score;
        }

        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/score.ts